// alterado - revisado

import {
    SvgIcon,
} from '@material-ui/core'

import { ReactComponent as diaDiaSvg } from './diaDia.svg'

import { ReactComponent as diaDiaDespesasTemporariasSvg } from './diaDiaDespesasTemporarias.svg'

import { ReactComponent as educacaoSvg } from './educacao.svg'

import { ReactComponent as financiamentoSvg } from './financiamento.svg'

import { ReactComponent as projetoVidaSonhoSvg } from './projetoVidaSonho.svg'



export const SvgIconDiaDia = ( props ) => {
    return (
        <SvgIcon
            component={diaDiaSvg}
            viewBox="0 0 24 24"
            {...props}
        />        
    )
}

export const SvgIconDiaDiaDespesasTemporarias = ( props ) => {
    return (
        <SvgIcon
            component={diaDiaDespesasTemporariasSvg}
            viewBox="0 0 24 24"
            {...props}
        />        
    )
}

export const SvgIconEducacao = ( props ) => {
    return (
        <SvgIcon
            component={educacaoSvg}
            viewBox="0 0 24 24"
            {...props}
        />        
    )
}

export const SvgIconFinanciamento = ( props ) => {
    return (
        <SvgIcon
            component={financiamentoSvg}
            viewBox="0 0 24 24"
            {...props}
        />        
    )
}

export const SvgIconProjetoVidaSonho = ( props ) => {
    return (
        <SvgIcon
            component={projetoVidaSonhoSvg}
            viewBox="0 0 24 24"
            {...props}
        />        
    )
}